import moment from 'moment-timezone';

export class ContractPerformanceMarketBreakdownDataPoints {
	public x: Date;
	public y: number;
	public yDisplay: number;
	public energy: number;
	public capacity: number;
	public congestion: number;
	public electricityBypass: number;
	public ancillary: number;
	public nymex: number;
	public basis: number;
	public total: number;
	public markerType: string;

	constructor(contractPerformanceMarketBreakdownDataPoints?: ContractPerformanceMarketBreakdownDataPoints) {
		Object.assign(this, contractPerformanceMarketBreakdownDataPoints);

		this.x = this.x ? new Date(moment(this.x).format('MMM DD, YYYY hh:mm:ss a')) : this.x;
	}
}
